// extracted by mini-css-extract-plugin
module.exports = {"badge":"BadgeColumn_badge__3ui_l"};